import { contentsType } from '../types';

const seasonalityContents: Array<contentsType> = [
  {
    title: 'Lebih dari 15 Tahun Price History',
    description:
      'Manfaatkan tren pergerakan harga pada setiap bulan sampai dengan lebih dari 15 tahun yang lalu. Karena ada bulan yang lebih baik dari bulan-bulan lainnya pada setiap tahun.',
    image: 'Seasonality_15_Years_Blue.jpg',
  },
  {
    title: 'Probabilitas Kenaikan',
    description:
      'Probabilitas kenaikan untuk setiap bulannya akan otomatis terhitung. Hint: $IHSG 100% positif pada bulan Desember selama 16 tahun terakhir.',
    image: 'Seasonality_Probabilitas_Blue.jpg',
  },
];

export default seasonalityContents;
